import { motion, AnimatePresence } from "framer-motion";
import { FiX } from "react-icons/fi";

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoId: string; // Changé de videoUrl à videoId
  title: string;
}

const VideoModal: React.FC<VideoModalProps> = ({
  isOpen,
  onClose,
  videoId,
  title,
}) => {
  // Construire l'URL YouTube à partir de l'ID
  const youtubeUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

  return (
    <AnimatePresence>
      {" "}
      {/* Correction de l'orthographe de AnimatePresence */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="video-modal-backdrop"
          onClick={onClose}
          style={{ zIndex: 999 }}
        >
          <motion.div
            initial={{ scale: 0.9, y: 20 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.9, y: 20 }}
            className="video-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={onClose}
              className="video-modal-close"
              aria-label="Fermer la vidéo"
            >
              <FiX size={24} />
            </button>
            <div className="video-modal-player-container">
              <iframe
                src={youtubeUrl}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="video-modal-player"
                frameBorder="0" // Ajout pour supprimer la bordure
              />
            </div>

          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default VideoModal;
